import { makeStyles } from '@material-ui/core';
import InboxIcon from '@material-ui/icons/InboxOutlined';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'sticky',
    left: '50%',
    right: '50%',
    maxWidth: 1,
  },
  content: {
    position: 'absolute',
    width: 'max-content',
    transform: 'translate(-50%, 40px)',
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    padding: '140px 240px',
    borderRadius: 10,
    border: '1px dashed #e0e0e0',
  },
  icon: {
    fontSize: 20,
    color: '#D9D9D9',
  },
  text: {
    fontSize: 13,
    color: theme.colors?.grey || '#8E8E8E',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
}));

const EmptyFallback = () => {
  const classes = useStyles();
  const {
    en: { tables },
  } = useSelector(state => state.i18n);

  return (
    <div className={`${classes.container} table-fallback`}>
      <div className={classes.content}>
        <InboxIcon className={classes.icon} />
        <div className={classes.text}>{tables?.noRecordsToDisplay || 'No records to display'}</div>
      </div>
    </div>
  );
};

export default EmptyFallback;
